import groqHandler, { processImages } from './sanity/groqHandler'

async function renderPage({
    params = null,
    error = [],
    payload = null,
    store = null,
    query = {},
    type = null,
    lang = 'en',
}) {
    if (payload) {
        // console.log('has payload')
        return {
            content: await processImages(payload),
            error,
            payload,
            type,
        }
    } else {
        // console.log('no payload')
        const page = await groqHandler({
            params,
            error,
            payload,
            store,
            query,
            type,
            lang,
        })
        return page
    }
}
export { renderPage as default }
